import React from 'react';
import './ContactSection.css';
import InputText from '../../components/TextInput';
import Button from '../../components/Button';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
const ContactSection = () => {
 
  return (
  <>
  <Header/>
    <div className="contact-section">
      <div className="row">
       
        <div className="col-md-6">
          <h2>Contact Us!</h2>
          <form className='contact-form'>
            <InputText
            type='text'
            placeholder='Name'
            />

           <InputText
            type='text'
            placeholder='Contact'
           
            />
           <InputText
            type='email'
            placeholder='Email'
            
            />
            
            
            <textarea
              className="form-control"
              rows="5"
              placeholder="Message (optional)"
            ></textarea>
            
            <Button
            text='Submit'
            />
          </form>
        </div>
     
        <div className="col-md-6 address-section">
          <h2>Where you can find us</h2>
          <p>
            <i className="fas fa-map-marker-alt"></i> GhaziKot Township, Sector A ,
            Upper Main Rd , Mansehra, KPK ,Pakistan  202077
          </p>
          <div>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6591.262331015436!2d73.20144094248168!3d34.30894219224524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38de3c7525c27db5%3A0x4c67e1837b4751e6!2sGhazikot%20Twp%20Mansehra%2C%20Mansehra%2C%20Khyber%20Pakhtunkhwa%2C%20Pakistan!5e0!3m2!1sen!2s!4v1732285398708!5m2!1sen!2s"
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              title="Google Maps"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </>
  );
};

export default ContactSection;
